module.exports = __webpack_public_path__ + "img/client-8.c4ddd479.webp";